<template>
  <div>
    <v-card class="elevation-0">
      <v-card-title class="pa-0">
      </v-card-title>
      <v-card-text >
        <date-search v-if="with_date_search" @onDateSearch="handleDateSearch"></date-search>
        
        <v-data-table
          mobile-breakpoint="1"
          :headers="comp_headers"
          :items="loading? [] : items"
          class="elevation-0"
          :search="tableSearch"
          ref='table'
          :loading='loading'
        >
          <template v-slot:top>
            <v-row justify="center" class="my-2" v-if="denied_permission_to_see_total_values">
              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                      <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-currency-usd</v-icon>
                      <span class="title">{{ loading ? 'Carregando...' : total_value_sum.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                      <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-receipt</v-icon>
                      <span class="title"> {{ loading ? 'Carregando...' : total_bills + ' faturas' }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
          
          <template v-slot:item.attributes.DateExpired="{item}">
            <span :class="isOverdue(item.attributes.DateExpired) && item.attributes.pay_status != 'done' ? 'red--text ' : ''">
              {{$moment(item.attributes.DateExpired).format('L')}}
            </span>
          </template>
          <template v-slot:item.order="{item}">
            <div v-if="item.attributes.external_order_id && item.attributes.solution == 'retail'">
              {{item.attributes.external_order_id}} 
            </div>
            <div v-if="item.attributes.order_id && item.attributes.solution == 'wholesale'">
              {{item.attributes.order_id}} 
            </div>
          </template>
          <template v-slot:item.attributes.solution="{item}">
            <div v-if="item.attributes.solution == 'wholesale'">
              Grandes Cargas
            </div>
            <div v-else-if="item.attributes.solution == 'retail'">
              {{ modality_name }}
            </div>
            <div v-else>--</div>
          </template>
          <template v-slot:item.attributes.ammount="{item}">
            {{Number(item.attributes.ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </template>
          <template v-slot:item.attributes.ammount_payed="{item}">
            {{Number(item.attributes.ammount - item.attributes.ammount_payed).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </template>
          <template v-slot:item.attributes.juros_paid="{item}">
            {{ formatJurosPaid(item) }}
          </template>
          <template v-slot:item.attributes.comment="{item}">
            <v-btn color="red" dark @click="seeComment(item.attributes.comment, item.attributes.additional_comments)" small icon> <v-icon>mdi-chat</v-icon> </v-btn>
          </template>

          <template v-slot:item.attributes.pay_status="{item}">
            <v-chip v-if="item.attributes?.fiscal_note?.id" class="mb-1" small color="success" text-color="white" @click="openNfeDialog(item.attributes.fiscal_note)"> 
              Visualizar NF-e 
              <v-icon small right>mdi-check-circle </v-icon> 
            </v-chip>
            <v-chip 
              small 
              :color="['available', 'done'].includes(item.attributes.pay_status) ? 'success' : 'orange'" 
              text-color="white">
              {{ pay_status_map[item.attributes.pay_status] }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{item}">
            <v-btn color="primary" @click="createProtest(item)" small icon :disabled="!['available', 'protested'].includes(item.attributes.pay_status) || !had_permission_to_protest"> <v-icon>mdi-gavel</v-icon> </v-btn>
            <v-btn color="primary" @click="updateDateExpired(item)" small icon :disabled="item.attributes.pay_status != 'available'  || !had_permission_to_date_expired"> <v-icon>mdi-calendar-edit</v-icon> </v-btn>
          </template>

        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="comment_dialog" v-if="comment_dialog" max-width="900px" transition="dialog-transition" >
      <v-card style="border-radius:4px">
        <v-card-title primary-title>
          <div class="headline mb-0">Comentários</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text :style="additional_comments.length > 0 ? 'overflow-y: auto; height: 25vh' : ''">
          <v-list>
            <v-list-item dense><span class="text-subtitle-1">Detalhes</span></v-list-item>
            <v-list-item dense>{{ comment }}</v-list-item>
            <v-list-item dense v-if="additional_comments.length > 0"><span class="text-subtitle-1">Informações adicionais</span></v-list-item>
            <v-list-item dense v-for="comment in additional_comments"><span style="text-wrap: pretty;">{{ comment }}</span></v-list-item>
          </v-list>
          
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="comment_dialog = !comment_dialog"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogNfInfo :dialog_nf_infos="dialog_nf_infos" :nf_infos="nf_infos"></DialogNfInfo>
    <router-view></router-view>
  </div>
</template>

<script>
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'
import status from "@/_backoffice/_financial/mixins/status.js"
import { mapState } from 'vuex'
import { isOverdue } from '@/utils/dueDate'

export default {
  name: "OrderTransactionsTable",
  components: {
    DateSearch: () => import('@/_backoffice/_financial/components/shared/DateSearch.vue'),
    DialogNfInfo: () => import('@/_backoffice/_financial/components/bill/shared/DialogNfInfo.vue'),
  },
  mixins: [SolutionMap, status],
  props: {
    items: {
      type: Array,
    },
    headers:{
      type: Array,
    },
    title:{
      type: String,
    },
    with_date_search: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    kind: {
      type: String,
      default: 'open'
    },
    /** Texto vindo do FilterData (busca no `v-data-table`). */
    tableSearch: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog_nf_infos: false,
      nf_infos: {},
      headers_default: [
        { text: 'Vencimento', value: 'attributes.DateExpired' },
        { text: 'Pedido(s)', value: 'order' },
        { text: 'Cliente', value: 'attributes.client_name' },
        { text: 'Módulo', value: 'attributes.place_name' },
        { text: 'Forma de pagamento', value: 'attributes.payment_description' },
        { text: 'Valor Total (R$)', value: 'attributes.ammount' },
        { text: 'Valor a pagar (R$)', value: 'attributes.ammount_payed' },
        { text: 'Juros pagos (R$)', value: 'attributes.juros_paid' },
        { text: 'Comentário', value: 'attributes.comment' },
        { text: "Status", value: "attributes.pay_status", align: 'center' },
      ],
      pay_status_map:{
        available: 'Disponível', 
        waiting_payment: 'Aguardando pagamento', 
        processing: 'Processando', 
        done: 'Finalizado', 
        error: 'Erro',
        protested: 'Protestado',
      },
      comment: '',
      additional_comments: [],
      comment_dialog: false,
      dialog_new_bill: false,
      vrt: {},
    }
  },
  methods: {
    isOverdue,
    openNfeDialog(data){
      this.dialog_nf_infos = !this.dialog_nf_infos
      this.nf_infos = data
    },
    seeComment(comment, additional_comments) {
      this.comment = comment
      this.additional_comments = additional_comments
      this.comment_dialog = true
    },
    formatJurosPaid(item) {
      const value = Number(item.attributes.juros_paid || 0)
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    handleDateSearch(e){
      this.$emit('dateSearched', e)
    },
    createProtest(vrt){
      this.$router.push({name: 'ToProtest', params: {id: vrt.attributes.id}})
    },
    updateDateExpired(vrt){
      this.$router.push({name: 'UpdateDateExpired', params: {id: vrt.attributes.id}})
    },
  },

  computed: {
    had_permission_to_protest(){
      return this.isDirector() || this.isAnalyst() || this.isCreditAnalyst()
    },
    had_permission_to_date_expired(){
      return this.isDirector() || this.isSalesExecutive()
    },
    comp_headers(){
      if(!this.items.some(el => el.attributes.pay_status == 'done')){
        let headers_data = [ ...this.headers_default, { text: 'Ações', value: 'actions',  align: 'center'}]
  
        if(this.isDirector() || this.isAnalyst() || this.isCreditAnalyst() || this.isSalesExecutive()) {
          return headers_data
        }
        if(this.items.some(el => el.attributes.pay_status == 'protested')){
          return headers_data
        }
      }
      return this.headers_default
    },
    denied_permission_to_see_total_values(){
      return !this.isClerk()
    },
    total_value_sum() {
      let sum = null
      if (this.kind == 'open'){
        sum = (acc, one)=> acc + (Number(one?.attributes?.ammount) - Number(one?.attributes?.ammount_payed))
      } else if (this.kind == 'paid'){
        sum = (acc, one)=> acc + Number(one?.attributes?.ammount)
      }
      if (this.tableSearch && this.$refs.table){
        return this.loading? 0 : this.$refs?.table?.internalCurrentItems?.reduce(sum ,0)
      }
      return this.loading ? 0 : this.items?.reduce(sum ,0)
    },

    total_bills() {
      if (this.tableSearch && this.$refs.table){
        return this.loading ? 0 : this.$refs.table.internalCurrentItems.length
      }
      return this.loading ? 0 : this.items.length
    },
    ...mapState({
      modality_name: state => state.App.activeModalityName,
    })
  },
}
</script>
